import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** The value stack — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-120" data-mp="1fmw5hbui9ams">
      <div className="mx-auto max-w-5xl" data-id="element-121" data-mp="28a9wyuffpdzi">
        <SectionHeading id="offer-heading" title={<>
              Your Complete Barber Teaching System <Accent data-id="element-123" data-mp="1yjxcf27mdktd">Is Ready.</Accent>
            </>} data-id="element-122" data-mp="28bky0mhhw7mx" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(20,40,59,0.45)]" data-id="element-124" data-mp="1yhkugp1v3agb">
          <div className="bg-brand-charcoal px-6 py-4 text-center" data-id="element-125" data-mp="2r6i4y5zu02yi">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-126" data-mp="3chib6yrbychr">
              Complete Barber Instructor System
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-127" data-mp="33pzw6r64e2q9">
            <img src={MOCKUP_URL} alt="Everything included in Barber Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[580px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(20, 40, 59, 0.16))'
          }} data-id="element-128" data-mp="33p7ynasypuxc" />

            <ul className="mx-auto mt-10 max-w-xl space-y-3.5" role="list" data-id="element-129" data-mp="2ksf4lcbz0q1y">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-130" data-mp="iz96a9oehufu">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-131" data-mp="n1cg6tvf8qz0" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex items-baseline justify-center gap-3 border-y border-brand-charcoal/10 py-6" data-id="element-132" data-mp="1qy6fwh7dqpwc">
              <span className="font-display text-[3rem] font-bold leading-none text-brand-gold" data-id="element-133" data-mp="1my4dg5ttlsg0">11</span>
              <span className="font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-charcoal" data-id="element-134" data-mp="1hzbcfcvpztwq">
                Digital Resources · Instant Delivery
              </span>
            </div>

            <CtaBlock label="Yes! I Want Instant Access" showPrice className="mt-9" data-id="element-135" data-mp="2anypwma89ezq" />
            <p className="mt-4 text-center font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-136" data-mp="25uxa8c275bf3">
              One payment · Digital access · No subscription
            </p>
          </div>
        </div>
      </div>
    </section>;
}